import Table from 'react-bootstrap/Table'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Alert from 'react-bootstrap/Alert'

export default function EntryPointsTable({
  entryPoints,
  handleShowEntryPointModal,
}) {
  return (
    <>
      <Row className="justify-content-md-end mb-3">
        <Col md="auto">
          <Button variant="primary" onClick={() => handleShowEntryPointModal()}>
            Add Entry Point
          </Button>
        </Col>
      </Row>
      {entryPoints && entryPoints.length > 0 ? (
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Name</th>
              <th>Venue</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {entryPoints.map((entryPoint) => (
              <tr key={entryPoint.id}>
                <td>{entryPoint.name}</td>
                <td>{entryPoint.venueName}</td>
                <td onClick={() => handleShowEntryPointModal(entryPoint)}>
                  <Button variant="link">Edit</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <Alert variant="light" className="mb-0">
          No entry points yet. Add an entry point before assigning scanners.
        </Alert>
      )}
    </>
  )
}
